import { render } from "./RotateDevice.vue?vue&type=template&id=412dd095"
const script = {}

import "./RotateDevice.vue?vue&type=style&index=0&id=412dd095&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__